module.exports = __webpack_public_path__ + "img/NL.5a6be3b5.jpg";